import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const NotificationCard = ({ notification, onClose }) => {
  const { title, message, link, linkText = "Click here", read } = notification;
  const parts = message.split("{{link}}");

  return (
    <>
      <p className="text-sm text-white flex-1 items-center justify-center">
        {parts[0]}
        <Link to={link} className="text-white underline hover:text-white mx-1">
          {linkText}
        </Link>
        {parts[1]}
        <button
          className="text-white hover:text-white p-1"
          onClick={() => {
            onClose(notification.id);
          }}
        >
          <X size={16} />
        </button>
      </p>
    </>
  );
};

export default NotificationCard;
